import * as types from '../types/assignedUsers'
import createReducer from '../createReducer'

const initialCvUsersState = {
  lastUpdatedUsers: '',
  isFetchingUsers: false,
  fetchUsersSuccess: false,
  fetchUsersFailure: false,
  fetchUsersError: '',
  users: [],
}

export default createReducer(initialCvUsersState, {
  // USERS
  [types.FETCH_ASSIGNED_USERS_SUCCESS](state, action) {
    return Object.assign({}, state, {
      users: action.users,
      lastUpdatedUsers: Date.now()
    })
  },
  [types.FETCH_ASSIGNED_USERS_FAILURE](state, action) {
    return Object.assign({}, state, {
      isFetchingUsers: false,
      fetchUsersSuccess: false,
      fetchUsersFailure: true,
      fetchUsersError: action.error,
    })
  },
})
